// 酒店名称常量
const MOTEL_NAME = '';

export const enMessage = {
  // 头部导航
  hello: 'Hello',
  lang_text: 'English',
  motelName: MOTEL_NAME,
  menuHome: 'Home',
  menuOrder: 'Order',
  menuMember: 'Member',
  menuActivity: 'Activity',
  menuMe: 'Account',
  menuLogin: 'Login',
  menuMembership: 'Membership',
  accommodation: 'Accommodation',
  location: 'Location',
BookNow: 'Book now',
  // 页尾部分：
  findUsOn: 'Find us on',
  contactUs: 'Contact us',
  requestMap: 'Request a map',
  reportProblem: 'Report a problem',
  help: 'Help',
  faqs: 'FAQs',
  about: 'About Sealand Travel',
  terms: 'Terms of use',
  privacy: 'Privacy policy',

  // 登陆对话框
  loginModal: {
    titleLogin: 'Login',
    titleRegister: 'Register',
    inputEmail: 'Email',
    inputPassword: 'Password',
    inputConfirmPassword: 'Confirm password',
    submitButton: 'OK',
    emailPlaceholder: 'Enter your email',
    passwordPlaceholder: 'Enter password',
    confirmPasswordPlaceholder: 'Enter password again',

    emailRequiredValidate: 'Email is required.',
    emailTypeValidate: 'Your enter is not a validate email.',
    passwordRequiredValidate: 'Password is required.',
    passwordLengthValidate: 'The length of password can not be less than 6.',
    confirmPasswordSomeValidate: 'Two passwords are not the same.',

    confirmButton: 'Confirm',
  },

  // 首页
  home: {
    title: MOTEL_NAME,
    beginTravel: 'Begin booking',
    checkinDate: 'CHECK IN DATE',
    checkoutDate: 'CHECK OUT DATE',
    search: 'SEARCH',
    activityShow: 'ACTIVITY',
    redeemProduct: 'REDEEM PRODUCT',
    searchError: 'Check in and check out date must be filled!',
  },

  // 房间搜索结果
  roomList: {
    title: MOTEL_NAME + ' - Search Rooms',
    roomCapacity: 'Room capacity',
    checkin: 'Check in',
    checkout: 'Check out',
    marketPirce: 'Market price',
    memberPrice: 'Membership price',
    oneNight: 'a night',
    startingAt: ' From ',
    totalPrice: 'total',
    cancelLimit: 'Cancellation policy',
    orderDesc: 'All taxes and fees included, except local tax if applicable.',
    detailButton: 'See details',
  },

  // 订单提交页面
  bookRoom: {
    title: MOTEL_NAME + ' - Order room',
    loginDesc: {
      loginOrRegister: 'Log in or register',
      loginDesc1: 'for fast and easy checkout whenever you see',
      loginDesc2: 'Book on ' + MOTEL_NAME + '.',
    },

    mainGuest: 'Main guest',
    guestNameDesc: 'Please enter the full name as it appears on their passport.',
    guestPoptipTitle: 'How to add guests',
    guestPoptipContent1: '1. Please enter the full name as it appears on their passport.',
    guestPoptipContent2: '2. Children under 18 must be accompanied by an adult guest.',

    firstName: 'First name',
    lastName: 'Last name',
    firstNamePlaceholder: 'Enter first name using Roman characters',
    lastNamePlaceholder: 'Enter last name using Roman characters',
    guestsNumber: 'Guests number',

    bookingContact: 'Booking contact',
    email: 'Email',
    emailPlaceholder: 'Enter your email',
    emailDesc: 'We’ll send your booking confirmation to this email address. Make sure it’s correct.',

    registerCheckbox: 'Register for more convenience and services',
    createPassword: 'Create password',
    confirmPassword: 'Confirm password',
    passwordPlaceholder: 'Enter password',
    confirmPasswordPlaceholder: 'Enter password again',

    phoneNumber: 'Phone number',
    regionPlaceholder: 'Select or search a country or region',
    phonePlaceholder: 'Enter your phone number',

    couponWay: 'Preferential way',
    chooseCoupon: 'Choose coupon',
    couponPlaceholder: 'Click to choose coupon',

    privacyPolicy1: 'By continuing you agree to our',
    privacyPolicy2: 'Terms of Service',
    privacyPolicy3: '&',
    privacyPolicy4: 'Privacy Policies.',

    bookButton: 'Book',

    checkinDate: 'Check in',
    checkoutDate: 'Check out',
    guests: 'Guests',
    stay: 'Stay',

    confirmCheckin: 'Confirmed at check-in',
    mealNotIncluded: 'Breakfast Not included',
    maxGuests1: 'Up to',
    maxGuests2: 'guests',
    payUpfront: 'Pay upfront',
    cancellation1: 'Free cancellation before',
    cancellation2: '',
    noRefundable: 'Non-refundable',

    taxesAndFees: 'Taxes and fees',
    tax1: 'Value Added Tax',
    total: 'Total',

    freeCancellation: 'Free cancellation',
    freeCancellationDesc1: 'Free cancellation before',
    freeCancellationDesc2: ' (local time of hotel). After that, you\'ll be charged 100% of the cost.',
    instantConfirmation: 'Instant confirmation',

    notNoneValidate: 'Cannot be empty.',
    englishNameValidate: 'First name and last name must using english characters.',
    emailValidate: 'Email is not validate.',
    passwordLengthValidate: 'The length of password must be more than 6 characters.',
    confirmPasswordValidate: 'Two passwords are not the same.',

    hopeRegisterModalTitle: 'Register gains score',
    hopeRegisterModalContent1: 'You seem to have made a order here, if you register now, you can gain ',
    hopeRegisterModalContent2: ' scores. Do you want to register now?',

    chooseGuestTitle: 'Choose a guest',
  },

  // 订单列表页
  order: {
    title: MOTEL_NAME + ' - Orders',

    // 登录后界面
    headerTitle: 'Orders',
    headerTabALL: 'All',
    headerTabNoCheckin: 'No check in',
    headerTabCheckin: 'Checked in',
    headerTabCancelled: 'Cancelled',

    orderNumber: 'Order ID',
    check_in: 'Check in',
    check_out: 'Check out',
    orderDetail: 'Order detail',
    noOrders: 'No orders',

    // 未登录的界面
    orderQueryTitle: 'Order query',
    orderQueryInputPlaceholder: 'Enter the order ID',
    orderQueryButton: 'OK',
    orderQueryDes: 'Enter the order ID and click the OK button, the order information will be sent to your email, please go to check.',
    orderQueryInputValidate: 'Order ID can not be empty.',
    sendModalText: 'Order information has been sent to your email, please go to check.',
  },

  // 订单详情页
  orderDetail: {
    title: MOTEL_NAME + ' - Order detail',

    headerTitle: 'Order detail',
    payButton: 'Pay',
    cancelButton: 'Cancel',

    roomDetailTitle: 'Room detail',
    roomName: 'Room name',
    roomType: 'Room type',
    stay: 'Stay',
    totalMoney: 'Total',
    orderStatus: 'Order status',
    GuestInfo: 'Guest information',
    guestName: 'Main guest name',
    checkin: 'Check in',
    checkout: 'Check out',
    phone: 'Phone',
    orderId: 'Order ID',
    orderInfo: 'Information',
    orderCreateTime: 'Order create time',

    payModal: {
      title: 'Online pay',
      content: 'Payment amount',
      button: 'Pay',
    }
  },

  // 会员页面
  member: {
    title: MOTEL_NAME + ' - Member',

    memberCardName: 'SEALAND TRAVEL MEMBER',
    greeting: 'Hi, Sealand Travel member',
    score: 'Score',
    coupons: 'Coupon',
    joinUs: 'Join us',
    scoreRedeem: 'Score redeem',
    memberActivity: 'Member activity',
    benefit: 'Benefit',
    getIt: 'Get it',

  },

  // 我的页面
  me: {
    title: MOTEL_NAME + ' - Profile',

    profile: 'Profile',
    name: 'Name',
    memberName: 'Sealand travel member',
    memberRank: 'Member rank',
    email: 'Email',
    cardName: 'SEALAND TRAVEL MEMBER',

    score: 'Score',
    redeem: 'Redeem',
    orders: 'Orders',
    seeOrders: 'See orders',
    myCoupons: 'Coupons',
    seeCoupons: 'See coupons',

    editGuests: 'Edit guest information',
    advices: 'Advices',
    changePassword: 'Change password',
    logout: 'Logout',

    logoutModalText: 'Do you want to log out?',
  },

  // 活动页面
  activity: {
    title: MOTEL_NAME + ' - Activity',

    activityBannerName: 'Sealand travel activity',

    activityStartDate: 'Start at',
    activityEndDate: 'End at',

  },

  // 优惠券列表页面
  couponList: {
    title: `${MOTEL_NAME} - Coupon`,

    myCouponTitle: 'My coupon',
    myScore: 'My score',
    myCouponDes: 'Click button to use',
    buttonText: 'Use it now',
    redeemableCouponTitle: 'Redeemable coupon',
    redeemableCouponDes: ' score can redeem',
    redeemButton: 'Redeem',

    redeemModalTitle: 'Get coupons with your score',

  },

  // 选择优惠券页面
  chooseCoupon: {
    title: `${MOTEL_NAME} - Choose coupon`,

    noCouponButton: 'Do not use coupon',
  },

  // 积分兑换页面
  integral: {
    title: `${MOTEL_NAME} - Score`,

    myProductTitle: 'My gifts',
    myScore: 'My score',
    productDesc: 'Show this to reception to get it',
    redeemableProductTitle: 'Score redeem',

    redeemModalTitle: 'Get gifts with your score',

  },

  // 意见和建议页面
  feedback: {
    title: `${MOTEL_NAME} - Feedback`,

    headerTitle: 'Feedback types',
    feedbackData: [
      {
        title: 'Web pages',
        showTypes: 'Login stuck collapse',
        reasons: ['Collapse', 'Can not login', 'Stuck', 'Web pages confusion', 'Others'],
      },
      {
        title: 'Check in experience',
        showTypes: 'Service hygiene facilities foods',
        reasons: ['Bad service', 'Bad hygiene', 'Imperfect of facilities'],
      },
      {
        title: 'Booking',
        showTypes: 'Service hygiene facilities foods',
        reasons: ['Booking failed', 'Pay failed', 'Can not choose room', 'Can not cancel order', 'Others'],
      },
      {
        title: 'Member policy',
        showTypes: 'Rank rights score',
        reasons: ['Scores are not received', 'Member rank', 'Unable to get membership benefits', 'Member information can not be modified', 'Others'],
      },
      {
        title: 'Preferential promotion',
        showTypes: 'Coupons gift discount',
        reasons: ['Can not use coupons', 'Unable to participate in the activity', 'Others'],
      },
      {
        title: 'Others',
        showTypes: 'Others',
        reasons: ['Others'],
      },
    ],

    // 提交反馈页面部分
    submitHeaderTitle: 'Feedback',
    feedbackReason: 'Feedback reason',
    feedbackReasonPlaceholder: 'Please choose feedback reason',
    feedbackContentPlaceholder: 'Please enter your feedback',
    submitButton: 'Submit',
    resetButton: 'Reset',
    feedbackReasonRequired: 'Feedback reason can not be empty.',
    feedbackContentRequired: 'Feedback content can not be empty.'

  },

  // --- 组件部分 --- start
  // 侧边栏
  sideBar: {
    memberName: 'Sealand member',
    memberId: 'Member ID',
    myAccount: 'My account',
    logout: 'Logout',

    logoutModalText: 'Do you want to log out?',

    coupons: 'Coupons',
    scoreGift: 'Score gift',
    guests: 'Guests',
    advice: 'Advice',
    changePassword: 'Change password',
    loginButton: 'Login',
  },
  // 修改密码
  changePassword: {
    title: 'Change password',
    oldPassword: 'Old password',
    newPassword: 'New password',
    confirmPassword: 'Confirm password',
    confirmPasswordPlaceholder: 'Enter new password again',
    submitButton: 'Submit',
    resetButton: 'Reset',

    oldPasswordValidate: 'Old password can not be empty.',
    newPasswordEmptyValidate: 'New password can not be empty.',
    newPasswordLengthValidate: 'The length of new password can not be less than 6.',
    confirmPasswordValidate: 'Confirm password can not be empty.',
    confirmPasswordSomeValidate: 'Confirm password and new password are not the same. ',
  },
  // 编辑常住人
  editGuest: {
    title: 'Guest',
    addButton: 'Add',

    editGuest: 'Edit guest',
    firstName: 'First name',
    firstNamePlaceholder: 'Enter first name using Roman characters',
    lastName: 'Last name',
    lastNamePlaceholder: 'Enter last name using Roman characters',
    okButton: 'Submit',
    resetButton: 'Reset',

    deleteGuest: 'Delete guest',
    deleteText: 'Do you want to delete this guest?',
  },
  // --- 组件部分 --- end
}
